import linkifyHtml from 'linkify-html';

interface UrlParameters {
  [key: string]: string;
}

interface LinkOptions {
  attributes?: {
    [key: string]: Array<string> | string;
  };
  className?: string;
  target?: {
    url: string;
  };
}

type OptionFunction = (url: string) => Partial<LinkOptions>;

export const getUrlParameter = (url: string): UrlParameters => {
  const regex = /[?&]([^=#]+)=([^&#]*)/g;
  const params: UrlParameters = {};

  let match = regex.exec(url);
  while (match) {
    params[match[1]] = decodeURIComponent(match[2]);
    match = regex.exec(url);
  }

  return params;
};

export const linkifyUrls = (
  str: string,
  option: OptionFunction = () => ({}),
): string => {
  const regex = /(https?:\/\/[^\s]+)/g;

  const linkified = str.replace(regex, (url) => {
    const options: LinkOptions = {
      target: {
        url: '_blank',
      },
      className: 'linkified',
      ...option(url),
    };

    return linkifyHtml(url, options);
  });

  return linkified;
};

export const strContainsUrl = (str: string): boolean => {
  if (typeof str !== 'string') {
    return false;
  }

  const regex = /https?:\/\/([\da-z.-]+)\.([a-z.]{2,6})([/\w .?-]*)*\/?/g;
  const urls = str.match(regex);

  return (urls && urls.length > 0) || false;
};
